import axios from "axios";
import makeApiCall from "./master/axiosIndex";

export const expensesApis = {
    // Payment In APIs
    createPaymentIn: (data: any): Promise<any> => {
        console.log('createPaymentIn API called with:', data);
        return makeApiCall({
            url: "/expenses/paymentIn/create",
            method: "post",
            data,
        });
    },

    updatePaymentIn: (data: any): Promise<any> =>
        makeApiCall({
            url: "/expenses/paymentIn/update",
            method: "put",
            data,
        }),

    // Payment Out APIs
    createPaymentOut: (data: any): Promise<any> =>
        makeApiCall({
            url: "/expenses/paymentOut/create",
            method: "post",
            data,
        }),

    updatePaymentOut: (data: any): Promise<any> =>
        makeApiCall({
            url: "/expenses/paymentOut/update",
            method: "put",
            data,
        }),

    // Expense Report APIs
    createExpenseReport: (data: any): Promise<any> =>
        makeApiCall({
            url: "/expenses/expenseReport/create",
            method: "post",
            data,
        }),

    updateExpenseReport: (data: any): Promise<any> =>
        makeApiCall({
            url: "/expenses/expenseReport/update",
            method: "put",
            data,
        }),

    // Fetch APIs
    fetchPayment: (expenseId: string | number): Promise<any> =>
        makeApiCall({
            url: `/expenses/fetchPayment/${expenseId}`,
            method: "get",
        }),

    fetchReport: (expenseReportId: string | number, params?: any): Promise<any> =>
        makeApiCall({
            url: `/expenses/fetchReport/${expenseReportId}`,
            method: "get",
            params,
        }),

    fetchExpenses: (projectId: string | number, params?: any): Promise<any> =>
        makeApiCall({
            url: `/expenses/fetchExpenses/${projectId}`,
            method: "get",
            params,
        }),

    fetchExpensesByReport: (expenseReportId: string | number, params?: any): Promise<any> =>
        makeApiCall({
            url: `/expenses/fetchExpensesByReport/${expenseReportId}`,
            method: "get",
            params,
        }),

    fetchReports: (projectId: string | number, params?: any): Promise<any> =>
        makeApiCall({
            url: `/expenses/fetchReports/${projectId}`,
            method: "get",
            params,
        }),

    fetchReportDropdown: (projectId: string | number): Promise<any> =>
        makeApiCall({
            url: `/expenses/fetchReportDropdown/${projectId}`,
            method: "get",
        }),

    fetchUnlinkedAdvances: (projectId: string | number): Promise<any> =>
        makeApiCall({
            url: `/expenses/fetchUnlinkedAdvances/${projectId}`,
            method: "get",
        }),

    linkAdvanceToReport: (data: any): Promise<any> =>
        makeApiCall({
            url: "/expenses/linkAdvanceToReport",
            method: "post",
            data,
        }),

    fetchUserSummary: (userId: string | number): Promise<any> =>
        makeApiCall({
            url: `/expenses/fetchUserSummary/${userId}`,
            method: "get",
        }),

    fetchProjectUsers: (projectId: any): Promise<any> =>
        makeApiCall({
            url: `/project/users/${projectId}`,
            method: "get",
        }),

    fetchMerchantDropdown: (projectId: string | number): Promise<any> =>
        makeApiCall({
            url: `/expenses/fetchMerchantDropdown/${projectId}`,
            method: "get",
        }),

    fetchCategoryDropdown: (projectId: string | number): Promise<any> =>
        makeApiCall({
            url: `/expenses/fetchCategoryDropdown/${projectId}`,
            method: "get",
        }),

    fetchExpenseLedgerSummary: (projectId: string | number, params?: any): Promise<any> =>
        makeApiCall({
            url: `/expenses/fetchExpenseLedgerSummary/${projectId}`,
            method: "get",
            params,
        }),

    fetchExpensesApprovals: (params?: any): Promise<any> =>
        makeApiCall({
            url: `/expenses/fetchExpensesApprovals`,
            method: "get",
            params,
        }),

    // Delete APIs
    deletePaymentIn: (paymentInId: string | number): Promise<any> =>
        makeApiCall({
            url: `/expenses/paymentIn/delete/${paymentInId}`,
            method: "delete",
        }),

    deletePaymentOut: (paymentOutId: string | number): Promise<any> =>
        makeApiCall({
            url: `/expenses/paymentOut/delete/${paymentOutId}`,
            method: "delete",
        }),

    deleteReport: (expenseReportId: string | number): Promise<any> =>
        makeApiCall({
            url: `/expenses/deleteReport/${expenseReportId}`,
            method: "delete",
        }),

    deleteExpense: (expenseId: string | number): Promise<any> =>
        makeApiCall({
            url: `/expenses/delete/${expenseId}`,
            method: "delete",
        }),


    // Approval APIs
    createExpenseApprovals: (data: { reportId: number; expenseId: number | string | string[] }): Promise<any> =>
        makeApiCall({
            url: "/expenses/createExpenseApprovals",
            method: "put",
            data,
        }),

    createReportApprovals: (data: { reportId: number; expenseId?: number }): Promise<any> =>
        makeApiCall({
            url: "/expenses/createReportApprovals",
            method: "put",
            data,
        }),

    approveExpense: (data: { expenseApprovalId: number; reason?: string }): Promise<any> =>
        makeApiCall({
            url: "/expenses/approveExpense",
            method: "put",
            data,
        }),

    bulkApproveExpenses: (data: { expenseApprovalId: string; reason?: string }): Promise<any> =>
        makeApiCall({
            url: "/expenses/approveExpense",
            method: "put",
            data,
        }),

    approveReport: (data: { reportId: number | string; reason?: string }): Promise<any> =>
        makeApiCall({
            url: "/expenses/approveReport",
            method: "put",
            data,
        }),

    rejectExpense: (data: { expenseApprovalId: number; reason: string }): Promise<any> =>
        makeApiCall({
            url: "/expenses/rejectExpense",
            method: "put",
            data,
        }),

    rejectReport: (data: { reportId: number | string; reason: string }): Promise<any> =>
        makeApiCall({
            url: "/expenses/rejectReport",
            method: "put",
            data,
        }),

    // OCR API - Process receipt file and extract data
    processReceiptOCR: async (file: File, paymentId: string | number): Promise<any> => {
        const formData = new FormData();
        formData.append("file", file);

        const url = process.env.REACT_APP_OCR_URL ?? "";
        return axios.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    },

    // Fetch payment data by ID (for OCR response)
    fetchPaymentOut: (paymentId: string | number): Promise<any> =>
        makeApiCall({
            url: `/expense/paymentout/${paymentId}`,
            method: "get",
        }),
};
